module.exports = __webpack_public_path__ + "img/faming1.b4eec013.png";